import config from '@/config'
import axios from 'axios'
import {store} from "@/store/store"
import router from '@/router'
import { join } from 'path';
import moment from "moment";


export default{
	authDefault: function(creds,callback){
		axios.post(config.serverUrl + 'adminlogin', { userid: creds.userid, password: creds.password, 'g-recaptcha-response': creds['g-recaptcha-response']})
			.then(response => {
				var response = response.data
				if (response.responsecode == 200) {
					callback(null, response)
				} else if (response.responsecode == 400) {
					let message = response.reason ? response.reason : 'Something went wrong, please try again'
					store.dispatch('logout', { 'error': { 'code': response.responsecode, 'message': message } }).then(function(){
						router.push('/nigol')
					})

					// router.push('/nigol')
					callback(new Error(message))
				} else {
					if (response.reason) {
						callback(new Error(response.reason))
					} else {

					}
				}
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	getLongLiveToken: function(creds,callback){
		axios.get(config.serverUrl + 'getlonglivetoken?appid='+config.appid+'&accesstoken='+creds.accessToken)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	getPageList: function(data,callback){
		axios.get('https://graph.facebook.com/v3.1/me/accounts?access_token=' + data.token +'&limit=1000&fields=access_token,category,category_list,id,tasks,name,name_with_location_descriptor')
		    .then(response => {
		      // JSON responses are automatically parsed.
		      var response = response.data
		      if (response.data) {
		      	let pagelist = []
		      	$.each(response.data,function(index,value){
					var page = Object.assign({},value)
					page.name = page.name_with_location_descriptor

					if (value.perms) {
						
						if (value.perms.indexOf('ADMINISTER') > -1||value.perms.indexOf('EDIT_PROFILE') > -1) {

							pagelist.push(page);
						}
					}
					if (value.tasks) {
						if (value.tasks.indexOf('MANAGE') > -1 || value.tasks.indexOf('CREATE_CONTENT') > -1) {
							pagelist.push(page);
						}
					}
		      	})
		      	callback(null,pagelist)
		      } else {
		      	callback(new Error(response.reason))
		      }
		    })
		    .catch(e => {
		    	callback(new Error('session expire. Please login again.'))
		    })
	},

	getBotList: function(data,token,callback){
		axios.defaults.headers.common = {
		    'authorization': token
			};
		axios.post(config.serverUrl + 'checkbotlist',data)
		    .then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	getAllPublicTheme: function(data,callback){
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.get(config.serverUrl + 'getallpublictheme?appid=' + data.appid)
		    .then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	getProducts: function(data,callback){
		let url = config.serverUrl + 'products?pageid='+data.pageid
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.get(url)
		    .then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	getCategories: function(pageid,callback){
		let url = config.serverUrl + 'categories?pageid='+pageid
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.get(url)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	saveProduct: function(data,callback){
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.post(config.serverUrl + 'products', data)
		    .then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	editProduct: function(data,callback){
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.put(config.serverUrl + 'products?id=' + data.id, data)
		    .then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	deleteProduct: function(data,callback){
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.delete(config.serverUrl + 'products?id='+data)
		    .then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	getSignedRequest: function(data,callback){
		let url = config.serverUrl + 'sign-s3?file-name=' + data.name + '&file-type=' + data.type

		axios.get(url)
		    .then(response => {
		      // JSON responses are automatically parsed.
		      var response = response.data
		      response.file = data.file
		      this.uploadfile(response,function(){
		      	callback(null,response.url)
		      })
		    })
		    .catch(e => {
		    	callback(new Error('session expire. Please login again.'))
		    })

	},

	uploadfile: function(data, callback){
		let signedRequest = data.signedRequest
		let request = data.file
		const xhr = new XMLHttpRequest()
		xhr.open('PUT', signedRequest)
		xhr.onreadystatechange = () => {
		  if(xhr.readyState === 4){
		    if(xhr.status === 200){
		    	callback();
		    }
		    else{
		      alert('Could not upload file.');
		    }
		  }
		};
		xhr.send(request);
	},

	saveCategory: function(data, callback){
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.post(config.serverUrl + 'categories', data)
		    .then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	editCategory: function(data, callback){
		let request = {
			name : data.name
		}
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.put(config.serverUrl + 'categories?id='+data.id, request)
		    .then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	deleteCategory: function(data, callback){
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.delete(config.serverUrl + 'categories?id='+data)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	saveSubCategory: function(data, callback){
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.post(config.serverUrl + 'subcategories', data)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	deleteSubCategory: function(data, callback){
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.delete(config.serverUrl + 'subcategories?id='+data)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	editSubCategory: function(data, callback){
		let request = {
			name : data.name
		}
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.put(config.serverUrl + 'subcategories?id='+data.id, request)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	getProductStock: function(productid,callback){
		let url = config.serverUrl + 'productstock?productid='+productid

		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.get(url)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	saveProductStock: function(data,callback){
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.post(config.serverUrl + 'productstock?productid=' + data.productid, data)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	editProductStock: function(data, callback){
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.put(config.serverUrl + 'productstock?productstockid='+data.id, data)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	deleteProductStock: function(data, callback){
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.delete(config.serverUrl + 'productstock?productstockid='+data)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	newSubscribe: function(data, callback){
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.post(config.serverUrl + 'newsubscribe', data)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	unSubscribe: function(data, callback){
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.post(config.serverUrl + 'unsubscribe', data)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	getAllUsers: function(data, callback){
		let url = config.serverUrl + 'getallusers?pageid=' + data['pageid'] + '&offset=' + data['offset'] + '&limit=' + data['limit']
		if (data['grouptype'] && data['grouptype'] != "") {
			url += '&grouptype=' + data['grouptype']
		}
		if (data['filter']) {
			url += '&' + this.joinFilter(data['filter'], store.getters.getPackage == 'premium')
			
		}
		// console.log(data['filter'])
		// console.log(url)
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.get(url)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	multicast: function(data , callback){
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.post(config.serverUrl + 'multicast', data)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	toggleBotStatus: function(data, callback){
		let url = !data.status ? 'stopbot' : 'startbot'
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.post(config.serverUrl + url, data)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	checkBotlist: function(data,callback){
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.post(config.serverUrl + 'checkbotlist',data)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	saveWelcomeMessage: function(data,callback){
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.post(config.serverUrl + 'botwelcomemessage',data)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	getWelcomeMessage: function(data,callback){
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.get(config.serverUrl + 'botwelcomemessage?pageid=' + data['pageid'])
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	getLiveChatUsers: function(data,callback){
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.get(config.serverUrl + 'getuserthread?pageid=' + data['pageid'] + '&inbox=' + data['type']+'&limit=' + data['limit'] + '&offset=' + data['offset'])
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	getUserMessages: function(data,callback){
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.get(config.serverUrl + 'getchatlog?userid=' + data['userid'] + '&adminid=' + data['adminid'] + '&limit=' + data['limit'] + '&offset=' + data['offset']+ '&pageid=' + data['pageid'])
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	sendMessage: function(data,callback) {
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.post(config.serverUrl + 'sendmessage',data)
		    .then(response => {
		    	this.defaultResponse(response,callback)
		    })
		    .catch(e => {
		    	this.defaultError(e,callback)
		    }) 
	},

	endSessionChat: function(data,callback) {
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.post(config.serverUrl + 'endconversation',data)
		    .then(response => {
		    	this.defaultResponse(response,callback)
		    })
		    .catch(e => {
		    	this.defaultError(e,callback)
		    }) 
	},

	getIntent: function(data,callback){
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.get(config.serverUrl + 'intents?pageid=' + data['pageid'] )
		    .then(response => {
		      this.defaultResponse(response,callback)
		    })
		    .catch(e => {
		    	this.defaultError(e,callback)
		    })
	},

	addIntent: function(data, callback){
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.post(config.serverUrl + 'intents', data)
		    .then(response => {
		      this.defaultResponse(response,callback)
		    })
		    .catch(e => {
		    	this.defaultError(e,callback)
		    })
	},

	editIntent: function(data, callback) {
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.put(config.serverUrl + 'intents?id='+data['id'], data)
		    .then(response => {
		      this.defaultResponse(response,callback)
		    })
		    .catch(e => {
		    	this.defaultError(e,callback)
		    })
		},

	deleteIntent: function (data, callback) {
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.delete(config.serverUrl + 'intents', { params: data})
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	getDashboardSummary: function(data, callback) {
		var url = config.serverUrl + 'pagereport_summary?pageid=' + data['pageid'] + '&datefrom=' + data['datefrom'] + '&dateto=' + data['dateto'] 
		if (data.app != 'all') {
			url += '&app=' + data.app
		}
		axios.get(url)
		    .then(response => {
		      this.defaultResponse(response,callback)
		    })
		    .catch(e => {
		    	this.defaultError(e,callback)
		    })
		},

	getDashboardIntent: function(data, callback) {
		var url = config.serverUrl + 'pagereport_intents?pageid=' + data['pageid'] + '&datefrom=' + data['datefrom'] + '&dateto=' + data['dateto'] 
		if (data.app != 'all') {
			url += '&app=' + data.app
		}
		if (data.group) {
			url += '&intentgroup=' + data.group
		}
		axios.get(url)
		    .then(response => {
		      this.defaultResponse(response,callback)
		    })
		    .catch(e => {
		    	this.defaultError(e,callback)
		    })
		},

	getDashboardActiveUserByDate: function(data, callback) {
		var url = config.serverUrl + 'pagereport_activeusers_bydate?pageid=' + data['pageid'] + '&datefrom=' + data['datefrom'] + '&dateto=' + data['dateto']
		if (data.app != 'all') {
			url += '&app=' + data.app
		}
		axios.get(url )
		    .then(response => {
		      this.defaultResponse(response,callback)
		    })
		    .catch(e => {
		    	this.defaultError(e,callback)
		    })
		},

	getDashboardActiveUserByTime: function(data, callback) {
		var url = config.serverUrl + 'pagereport_activeusers_bytime?pageid=' + data['pageid'] + '&datefrom=' + data['datefrom'] + '&dateto=' + data['dateto'] + '&time_0=' + data['time_0'] + '&time_1=' + data['time_1']
		if (data.app != 'all') {
			url += '&app=' + data.app
		}
		axios.get(url)
		    .then(response => {
		      this.defaultResponse(response,callback)
		    })
		    .catch(e => {
		    	this.defaultError(e,callback)
		    })
	},

	getOrderSummary: function (data, callback) {
		var url = config.serverUrl + 'ordersummary?' 
		if (data.pageid && data.pageid != '' && data.pageid != null) {
			url += 'pageid=' + data['pageid'] 
			axios.defaults.headers.common = {
				'AUTHORIZATION': store.getters.securityToken
			};
		} else if (data.lineid && data.lineid != '' && data.lineid != null){
			url += 'lineid=' + data['lineid'] 
		}
		url += "&datefrom=" + data['datefrom'] + "&dateto=" + data['dateto'] + "&status=" + data['status']
		
		axios.get(url)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	editOrderSummary: function (data, callback) {
		var url = config.serverUrl + 'ordersummary?' 
		if (data.lineid && data.lineid != '' && data.lineid != null) {
			url += 'lineid=' + data['lineid'] + '&pageid=' + data['pageid'] 
		} else if (data.pageid && data.pageid != '' && data.pageid != null) {
			axios.defaults.headers.common = {
				'AUTHORIZATION': store.getters.securityToken
			};
			url += 'pageid=' + data['pageid'] 
		} 
		url += '&id=' + data.id
		axios.put(url, data)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	getShopProfile: function (data, callback) {
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.get(config.serverUrl + 'shopprofile?pageid=' + data['pageid'] )
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	editShopProfile: function (data, callback) {
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.put(config.serverUrl + 'shopprofile?pageid=' + data.pageid, data)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	getLineNotifySubscriber: function (data, callback) {
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.get(config.serverUrl + 'notifyadminuser?pageid=' + data['pageid'])
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	deleteLineNotifySubscriber: function (data, callback) {
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.post(config.serverUrl + 'notifyadminuser_remove?pageid=' + data['pageid'] + '&userid=' + data['userid'], data)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	sendMessageLine: function (data, callback) {
		axios.post(config.serverUrl + 'sendmessageline', data)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	getChatlogLine: function (data, callback) {
		axios.get(config.serverUrl + "getchatlog?userid=" + data["userid"] + "&adminid=" + data["adminid"] + "&pageid=" + data["pageid"] + "&limit=" + data["limit"] + "&offset=" + data["offset"])
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	getChatUsersLine: function (data, callback) {
		// axios.defaults.headers.common = {
		// 	'AUTHORIZATION': store.getters.securityToken
		// };
		axios.get(config.serverUrl + 'getuserthread?pageid=' + data['pageid'] + '&app=' + data['app'] + '&inbox=' + data['type'] + '&limit=' + data['limit'] + '&offset=' + data['offset'])
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	getPaypalUrl: function (data, callback) {
		axios.get(config.serverUrl + 'getpaypal_registerurl')
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	getPaypalTrackingStatus: function (data, callback) {
		axios.get(config.serverUrl + 'getpaypal_trackingstatus?tracking_id=' + data['tracking_id'])
			.then(response => {
				// this.defaultResponse(response, callback)
				callback(null, response.data)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	updatePaypalMerchantId: function (data, callback) {
		//paypal_merchantid
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.put(config.serverUrl + 'updatepaypal_merchantid?pageid=' + data['pageid'],data)
			.then(response => {
				callback(null, response.data)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	getSetting: function (data, callback) {
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.get(config.serverUrl + "getallcontent?pageid=" + data["pageid"] )
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	getBotDetail: function (data, callback) {
		// console.log(store.getters.securityToken)
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.get(config.serverUrl + "checkbotpage?pageid=" + data["pageid"])
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	getPersistentMenu: function (data, callback) {
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.get(config.serverUrl + "messenger_profile?pageid=" + data["pageid"] + '&status=' + data["status"] + '&fields=persistent_menu&access_token=' + data["access_token"])
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},
	
	editPersistentMenu: function(data, callback) {
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.post(config.serverUrl + 'messenger_profile?pageid=' + data.pageid + '&status='+ data.status+ '&fields=persistent_menu&access_token='+ data.access_token, data)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	getTraningConversation: function (data, callback){
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.get(config.serverUrl + 'defaultchatlogs?pageid=' + data.pageid + "&intentname=" + data.intentname + "&datefrom=" + data.datefrom + "&dateto=" + data.dateto + "&app=" + data.app)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	updateTrainingConversation: function (data, callback) {
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.post(config.serverUrl + 'updatedefaultchatlogs',data)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	updateConfig: function(data, callback){
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.post(config.serverUrl + 'updateadminconfig', data)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	getBroadcast: function (pageid, callback) {
		let url = config.serverUrl + 'getbroadcast?pageid=' + pageid
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.get(url)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	estimateReach: function (data, callback) {
		let url = config.serverUrl + 'estimatereach?pageid=' + data.pageid
		if (data['filter'] && store.getters.getPackage == 'premium') {
			url += '&' + this.joinFilter(data['filter'], true)
		} else if (data['condition']){
			url += data['condition']
		}
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.get(url)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},
	
	updateBroadcast: function (data, callback) {
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		if (data['filter']) {
			var filter = ''
			filter += this.joinFilter(data['filter'],true)
			data.m_condition = filter
		}
		axios.post(config.serverUrl + 'savebroadcast', data)
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	deleteBroadcast: function (data, callback) {
		axios.defaults.headers.common = {
			'AUTHORIZATION': store.getters.securityToken
		};
		axios.delete(config.serverUrl + 'deletebroadcast', { params: data })
			.then(response => {
				this.defaultResponse(response, callback)
			})
			.catch(e => {
				this.defaultError(e, callback)
			})
	},

	

	// =============== default function =================

	defaultResponse: function(response,callback) {
		// store.dispatch('logout', { 'code': '400', 'message': 'Session expire. Please login again.'  }).then(function(){
		// 	router.push('/login')

		// })
		var vm = this
		var response = response.data
		if (response.responsecode == 200) {
			callback(null,response)
		} else if (response.responsecode == 400){
			let message = response.reason ? response.reason : ''
			var isFacebook = store.state.isFacebook
			// console.log('before',isFacebook)
			store.dispatch('logout', { 'code': response.responsecode , 'message' : message}).then(function(){
				// console.log('after', isFacebook)
				if (router.history.current.name != 'login' || router.history.current.name != 'nigol') {
					// console.log(router.history.current.name)
					if (isFacebook) {
						router.push('/login')
					} else {
						router.push('/nigol')
					}
				}
				callback(new Error('Session expire. Please login again.'))

			})
			
		} else {
			// console.log(response)
			if (response.reason) {
				callback(new Error(response.reason))
			} else {

			}
		}
	},

	defaultError: function(e,callback) {
		if (process.env.NODE_ENV !== 'production') {
			
			console.log(e)	
		}
		callback(new Error('Session expire. Please login again.'))
	},

	joinFilter: function(data , isPremium){
		var url = []
		if (data['gender']) {
			url.push('gender=' + data['gender'])
		}
		if (data['fullname']) {
			url.push('fullname=' + data['fullname'])
		}
		if (data['app']) {
			if (data['app'] != 'all') {
				url.push('app=' + data['app'])
			}
		}
		if (data['locale']) {
			var locales = []
			$.each(data['locale'], function (index, locale) {
				locales.push(locale.value)
			})
			url.push('locale=' + locales.join(','))
		}
		if (data['activeDate']['start']) {
			url.push('timestamp_from=' + moment(data['activeDate']['start']).format('YYYY-MM-DD'))
		}
		if (data['activeDate']['end']) {
			url.push('timestamp_to=' + moment(data['activeDate']['end']).format('YYYY-MM-DD'))
		}
		if (data['registerDate']['start']) {
			url.push('registertimestamp_from=' + moment(data['registerDate']['start']).format('YYYY-MM-DD'))
		}
		if (data['registerDate']['end']) {
			url.push('registertimestamp_to=' + moment(data['registerDate']['end']).format('YYYY-MM-DD'))
		}

		if (isPremium) {

			if (data['email']) {
				url.push('email=' + data['email'])
			}
			if (data['phoneno']) {
				url.push('phoneno=' + data['phoneno'])
			}
			if (data['status']) {
				url.push('status=' + data['status'])
			}
			if (data['intent']) {
				url.push('intent=' + data['intent'].join(','))
			}
			if (data['timezone']['from'] || data['timezone']['to']) {
				
				var timezone = []
				if (data['timezone']['from']) {
					timezone.push(data['timezone']['from'])
				}
				if (data['timezone']['to']) {
					timezone.push(data['timezone']['to'])
				}
				url.push('timezone=' + timezone.join(','))
			}
			
			if (data['messagesent']['value'] != null && data['messagesent']['value'] != "") {
				url.push('messagesent=' + data['messagesent']['symbol'] + data['messagesent']['value'])
			}
		}


		return url.join('&')
	}
}



// WEBPACK FOOTER //
// ./src/api/index.js